export class TicketForm {
  title: string = "";
  message: string = "";
  ticketImages: string[] = [];
  priority: string = "";
}
export interface ITicketItem {
  ticketId: string;
  title: string;
  priority: string;
  status: string;
  reviewer: any;
  vendorId: any;
  createdAt: string;
  message: [
    {
      ticketMessageId: string;
      ticketId: string;
      message: string;
      ticket: any;
      createdAt: string;
      updatedAt: any;
    }
  ];
  ticketImages: [
    {
      ticketImagesId: string;
      ticketId: string;
      ticketImageUrl: string;
      ticket: any;
      createdAt: string;
      updatedAt: any;
    }
  ];
}
export interface ITicketResponse {
  data: ITicketItem[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export interface IImalURlResponse {
  result: {
    responseCode: string;
    responseMessage: string;
    isSuccessful: boolean;
    data: {
      id: string;
    };
  };
  id: number;
  exception: any;
  status: number;
  isCanceled: boolean;
  isCompleted: boolean;
  isCompletedSuccessfully: boolean;
  creationOptions: number;
  asyncState: any;
  isFaulted: boolean;
}

export interface IImalURl {
  postedFilebase64: string;
  documentName: string;
  filetype: string;
}
